import './style.scss';

const REVIEW_STATUSES = {
  pending: {
    label: 'Pendiente de revisión',
    icon: 'schedule'
  },
  approved: {
    label: 'Aprobado',
    icon: 'check_circle'
  },
  needs_correction: {
    label: 'Requiere subsanación',
    icon: 'error'
  }
};

function EvidenceReviewStatus({ status, observations }) {
  const normalizedStatus = String(status || 'pending').trim().toLowerCase();
  const statusInfo = REVIEW_STATUSES[normalizedStatus] || REVIEW_STATUSES.pending;
  const normalizedObservations = String(observations || '').trim();
  const badge = (
    <span className={`evidence-review-status__badge is-${normalizedStatus}`}>
      <span className='material-symbols-rounded'>{statusInfo.icon}</span>
      {statusInfo.label}
      {normalizedObservations && (
        <span className='material-symbols-rounded evidence-review-status__expand'>expand_more</span>
      )}
    </span>
  );

  if (!normalizedObservations) {
    return <div className='evidence-review-status'>{badge}</div>;
  }

  return (
    <details className='evidence-review-status'>
      <summary aria-label={`${statusInfo.label}. Ver observaciones`}>
        {badge}
      </summary>
      <div className='evidence-review-status__observations'>
        <strong>Observaciones del revisor</strong>
        <p>{normalizedObservations}</p>
      </div>
    </details>
  );
}

export default EvidenceReviewStatus;
